import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from '../layout/SVGImage';
import { OutlinedButton } from '../common/OutlinedButton';

interface OperationManagementResourceTableProps {
  data: Array<ResourceListTableData>;
  testId?: string;
  className?: string;
  onClick?: () => void;
}

export const OperationManagementResourceTable: React.FC<
  OperationManagementResourceTableProps
> = ({ data, testId, className }) => {
  const { t } = useTranslation();

  const headers = [
    t('management.resourceName'),
    t('management.resourceCode'),
    t('management.generatorCapacity', { context: 'short2' }),
    t('management.virtualPowerPlantCode'),
    t('management.memberCompanyName'),
    t('management.associatedPowerPlant'),
    t('management.edit'),
  ];
  return (
    <table data-testid={testId} className={`${className} w-full`}>
      <thead>
        <tr className="h-[36px] rounded-[5px] bg-dark-4 text-white">
          {headers.map((value, index) =>
            index === 0 ? (
              <th
                key={index}
                className={`pop-normal-3 rounded-bl-[5px] rounded-tl-[5px] ${index === 0 || index === 1 ? 'pl-7 text-start' : ''}`}
              >
                {value}
              </th>
            ) : index === headers.length - 1 ? (
              <th
                key={index}
                className="pop-normal-3 rounded-br-[5px] rounded-tr-[5px]"
              >
                {value}
              </th>
            ) : (
              <th
                key={index}
                className={`pop-normal-3 ${index === 0 || index === 1 ? 'pl-7 text-start' : ''}`}
              >
                {value}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {data.map((value, index) => (
          <tr key={index} data-testid={`${testId}-item`}>
            {Object.values(value).map((value, index) => {
              const associatedPowerPlantIndex = 5;

              return (
                <td
                  className={`noto-normal-3 border-b border-[#E2E7E7] py-[13px] text-center leading-none tracking-[-0.5px] text-dark-6 ${index === 0 || index === 1 ? 'pl-7 text-start' : ''}`}
                  key={index}
                >
                  <div
                    className={`flex items-center ${index === 0 || index === 1 ? 'justify-start' : 'justify-center'}`}
                  >
                    {value}
                    {index === associatedPowerPlantIndex && (
                      <OutlinedButton
                        testId={`${testId}-associated-plant-button`}
                        className="ml-[14px] h-[26px] w-[42px] [&>p]:noto-medium-3 [&>p]:mx-auto [&>p]:my-auto [&>p]:w-full"
                        text={t('management.setting')}
                        isClicked={false}
                      />
                    )}
                  </div>
                </td>
              );
            })}
            <td className="pop-13-normal border-b border-[#E2E7E7] text-center leading-none text-dark-6">
              <div className="flex justify-center">
                <SVGImage
                  name="edit"
                  className="mr-[14px] cursor-pointer"
                  testId={`${testId}-setting-update`}
                />
                <SVGImage
                  name="delete"
                  className="cursor-pointer"
                  testId={`${testId}-setting-delete`}
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
